import { DELETE_TAB_REQUEST, DELETE_TAB_SUCCESS, DELETE_TAB_FAILURE } from './types'
import axiosInstance from '../../utils/api'
import { getLeaderboardTabs } from './leaderboardTabs'

// Existing actions remain unchanged...

// New delete actions
export const deleteTabRequest = () => {
  return {
    type: DELETE_TAB_REQUEST,
  }
}

export const deleteTabSuccess = (value) => {
  return {
    type: DELETE_TAB_SUCCESS,
    payload: value,
  }
}

export const deleteTabFailure = (error) => {
  return {
    type: DELETE_TAB_FAILURE,
    payload: error,
  }
}

export const deleteLeaderboardtab = (tabId) => async (dispatch) => {
  dispatch(deleteTabRequest())

  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post('/api/admin/lbtab/delete', { id: tabId })
      const result = response.data
      dispatch(deleteTabSuccess(result))
      dispatch(getLeaderboardTabs())
      resolve(result)
    } catch (error) {
      const errorMsg = error?.response?.data?.message || 'Unknown error'
      dispatch(deleteTabFailure(errorMsg))
      reject(errorMsg)
    }
  })
}
